export const environment = {
  production: true,
  apiURL: 'https://api-test.devmonagil.fr',
  apiNewUrl: 'https://localhost:8000',
  appURL: 'https://app-test.devmonagil.fr',
  vitrineURL: 'https://monagil.fr',
  stripe_key: 'pk_test_51GtCq2KXMSnQ7TAEi2Mx7XeQUzlggD7isdzllDed1WeYM0Am6xXWt4O9AaAAtw95NCSa4s0EUsmKuvgwNCPl0mNi00kzC3CBI4',
  socketUrl: 'wss://ws.devmonagil.fr',
  cguUrl: 'https://monagil.fr/cgu.pdf',
};
